import React, { useState } from 'react';
import { Button, Input, message, Modal, Switch } from 'antd';
import { useFormik } from 'formik';
import axios from '../../util/Api';

const Create = ({ refreshList }) => {
  const [open, setOpen] = useState(false);

  const formik = useFormik({
    initialValues: {
      title: undefined,
      content: undefined,
      display_order: undefined,
      is_active: true,
    },
    onSubmit: (values, actions) => {
      const url = `/faq/create`;
      const data = { ...values };
      axios.post(url, data).then(resp => {
        message.success(`FAQ dengan judul ${resp.data.title} telah berhasil disimpan`);
        setOpen(false);
        actions.setSubmitting(false);
        refreshList();
      }).catch(err => {
        message.error("Gagal menyimpan FAQ");
      });
    }
  });

  const handleOk = () => {
    formik.submitForm();
  }

  const handleCancel = () => {
    setOpen(false);
  }

  return (
    <>
      <Button type="primary" onClick={() => setOpen(true)}>Tambah FAQ</Button>
      <Modal title="Tambah FAQ" visible={open} onOk={handleOk} onCancel={handleCancel} okButtonProps={{loading : formik.isSubmitting}} okText="Simpan FAQ" cancelText="Batal">
        <form onSubmit={formik.handleSubmit}>
          <div className="gx-mb-2">
            <label htmlFor="title" className="gx-mb-1">Judul FAQ</label>
            <Input name="title" onChange={formik.handleChange} value={formik.values.title} />
          </div>

          <div className="gx-mb-3">
            <label htmlFor="content" className="gx-mb-1">Konten</label>
            <Input.TextArea rows={5} name="content" onChange={formik.handleChange} value={formik.values.content} />
          </div>

          <div className="gx-mb-3">
            <label htmlFor="content" className="gx-mb-1 gx-mr-3">Tampilkan</label>
            <Switch checkedChildren="Ditampilkan" unCheckedChildren="Tidak Ditampilkan" defaultChecked={formik.values.is_active} onChange={(e) => formik.setFieldValue("is_active", e)} />
          </div>
        </form>
      </Modal>
    </>
  );
}

export default Create;